/**
 * Группа тренажёра → задание мока (T3, виды Reading как на engnovate, шаг 1; 28.10.2026).
 *
 * Тренажёр рисует задания той же карточкой, что мок и спринт (`TaskCard` из
 * `components/ielts/MockTaskCard.tsx`): поле ответа в строке на месте «____», буквы A/B/C у выбора,
 * рамка у заметок и резюме — одинаково на компьютере и на телефоне (1.1.2). До этого у тренажёра
 * была своя карточка: выбор без букв, поле под вопросом.
 *
 * Значения ответов те же, что у прежней карточки тренажёра: текст варианта у выбора, ключ из
 * `CLOSED_CHOICES` у TRUE/FALSE/NOT GIVEN, текст у поля — проверка ответа на сервере не меняется.
 *
 * Номера вопросов — внутри группы, 1…n, как раньше. Подпись генератора («Questions 5–7») не
 * передаётся: она относится к исходному тексту, а тренажёр собирает группы из разных текстов —
 * номера в подписи спорили бы с номерами у вопросов.
 */
import type { UnitGroup } from '../api/ielts';
import type { PoolSkill, StudentTask } from '../api/ieltsMock';

export function trainerTask(group: UnitGroup, skill: PoolSkill): StudentTask {
  return {
    id: group.task_id,
    skill,
    type: group.type,
    instruction: group.instruction ?? '',
    group_label: '',
    options: group.options,
    layout: group.layout,
    questions: group.questions.map((q, i) => ({
      id: q.id,
      ord: i + 1,
      slot: q.slot,
      prompt: q.prompt,
      options: q.options,
      image_url: q.image_url,
    })),
  };
}
